import React from 'react';
import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './IndustrialScales.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-scroll';

import heroImage from '../Components/Images/Industrialweighing/indust1.png';
import scale1 from '../Components/Images/Industrialweighing/platform scale.avif';
import scale2 from '../Components/Images/Industrialweighing/waterproof.jpg';
import scale3 from '../Components/Images/Industrialweighing/counter scale.jpg';
import scale4 from '../Components/Images/Industrialweighing/precision scale.jpg'
import scale5 from '../Components/Images/Industrialweighing/bench scale.webp'

const IndustrialScales = () => {
  
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/contact-us'); 
  };

  const products = [
    {
      id: 1,
      name: 'Heavy-Duty Platform Scales',
      description: 'Industrial-grade platform scales with capacities up to 10,000 kg',
      image: scale1,
      features: ['Stainless steel construction', 'IP67 waterproof rating', 'Digital indicator'],
      badge: 'Best Seller',
      alter: 'heavy-duty platform weighing'
    },
    {
      id: 2,
      name: 'Waterproof Scale',
      description: 'It is Easy to use, battery operated stainless steel scale.',
      image: scale2,
      features: ['All sealed PCB design ', 'Single display or dual display', 'Auto power off timing selection '],
      badge: 'New',
      alter:'waterproof weighing scales for food industry'
    },
    {
      id: 3,
      name: 'Counting Scales',
      description: 'Multifunctional counting scale, can ensure more accurate piece counting result. It can support up to 60kg weight.',
      image: scale3,
      features: ['Up to 10 types of printing forms', 'State-of-art identical design', 'High resolution in 1/30,000'],
      badge: 'Premium',
      alter:'heavy-duty counting scales'
    },
    {
      id: 4,
      name: 'Precision Scales',
      description: 'Precision Balances are made for reliable and high-precision weighing. suitable for school lab, jewelry balance, gold scale.',
      image: scale4,
      features: ['LCD screen, bright and clear', 'Transparent glass windshield, sample seen clearly ', 'Multiple weighing unit conversion: g, ct, oz etc'],
      badge: 'Premium',
      alter:'precision bench scales'
    },
     {
      id: 5,
      name: 'Bench Scales',
      description: 'It can match different industrial indicators, such as JWI-3000W/3000C/3100/3000/ 586/688/700W/710/688/700C/700P/JIK-4/6/8,etc.',
      image: scale5,
      features: ['can be removed and wash down separately by water', 'Iron structure for durable performance', 'Non-slip adjustable feet'],
      badge: 'Best Seller',
      alter:'موازين طاولة / بن ش – Bench Scales'
    }
  ];

  return (
    <div className="industrial-scales-page">
      {/* Hero Section */}
      <section className="scales-hero">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="hero-content">
              <h1 className="display-4 fw-bold mb-4">Precision Industrial Weighing Solutions</h1>
              <p className="lead mb-4">High-accuracy scales engineered for demanding industrial environments</p>
              <div className="d-flex gap-4">
                <a href="/contact-us" className="my-btn btn btn-lg" style={{background:"#3ec63e", outline:"none", boxShadow:"none", color: "white", textDecoration: "none"}}>
                    Request Quote
                </a>
                
                <Link
                    to="product-section"
                    smooth={true}
                    duration={500}
                    className="my-btn btn btn-lg"
                    style={{background:"#3ec63e", color: "white", textDecoration: "none", cursor: "pointer"}}
                  >
                    View Products
                </Link>


              </div>
            </Col>
            <Col lg={6}>
              <img src={heroImage} alt="Industrial scales" className=" " />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Features Section */}
      <section className="features-section py-5 bg-light">
        <Container>
          <Row className="mb-5">
            <Col className="text-center">
              <h2 className="section-title1">Built for Industrial Demands</h2>
              <p className="section-subtitle text-muted">Engineered to perform in the toughest conditions</p>
            </Col>
          </Row>
        

            <Row className="align-items-stretch">
  {/* Feature 1 */}
  <Col md={4} className="mb-4">
    <div className="feature-item d-flex align-items-center p-3 bg-light rounded">
      {/* Left side - Icon */}
      <div className="feature-icon me-3">
        <i className="bi bi-shield-shaded fs-1"></i>
      </div>
      
      {/* Right side - Text content */}
      <div className="feature-content">
        <h3>Rugged Construction</h3>
        <p className="text-muted mb-0">Stainless steel and durable materials withstand harsh environments</p>
      </div>
    </div>
  </Col>
  
  {/* Feature 2 */}
  <Col md={4} className="mb-4">
    <div className="feature-item d-flex align-items-center p-3 bg-light rounded">
      {/* Left side - Icon */}
      <div className="feature-icon me-3">
        <i className="bi bi-speedometer2 fs-1 "></i>
      </div>
      
      {/* Right side - Text content */}
      <div className="feature-content">
        <h3>High Accuracy</h3>
        <p className="text-muted mb-0">Precision load cells with ±0.1% accuracy for reliable measurements</p>
      </div>
    </div>
  </Col>
  
  {/* Feature 3 */}
  <Col md={4} className="mb-4">
    <div className="feature-item d-flex align-items-center p-3 bg-light rounded">
      {/* Left side - Icon */}
      <div className="feature-icon me-3">
        <i className="bi bi-plugin fs-1"></i>
      </div>
      
      {/* Right side - Text content */}
      <div className="feature-content">
        <h3>Seamless Integration</h3>
        <p className="text-muted mb-0">Compatible with industrial systems and data collection software</p>
      </div>
    </div>
  </Col>
</Row>

         
        </Container>
      </section>

      {/* Products Section */}
      <section className="products-section py-5" id="product-section">
        <Container>
          <Row className="mb-5">
            <Col className="text-center">
              <h2 className="section-title1">Our Weighing Solutions</h2>
              <p className="section-subtitle text-muted">Find the perfect scale for your application</p>
            </Col>
          </Row>
          <Row>
            {products.map((product) => (
              <Col key={product.id} lg={4} md={6} className="mb-4">
                <Card className="h-100 product-card shadow-sm">
                  {product.badge && (
                    <Badge bg="success" className="position-absolute top-0 end-0 m-2">
                      {product.badge}
                    </Badge>
                  )}
                  <Card.Img variant="top" src={product.image} alt={product.alter} className="product-image" style={{objectFit:"contain"}} />
                  <Card.Body>
                    <Card.Title>{product.name}</Card.Title>
                    <Card.Text>{product.description}</Card.Text>
                    <ul className="features-list" style={{fontFamily:"Poppins", fontSize:"14px"}}>
                      {product.features.map((feature, index) => (
                        <li key={index}>{feature}</li>
                      ))}
                    </ul>
                  </Card.Body>
                  <Card.Footer className="bg-transparent border-top-0">
                    <Button variant="outline-success" className="w-100" onClick={handleClick}>View Details</Button>
                  </Card.Footer>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* CTA Section */}
      <section className="cta-section py-5 bg-secondary text-white">
        <Container>
          <Row className="align-items-center">
            <Col md={8}>
              <h2>Ready to Upgrade Your Weighing Process?</h2>
              <p className="mb-md-0">Our experts can help you select the perfect scale for your specific needs.</p>
            </Col>
            <Col md={4} className="text-md-end">
              <Button variant="light" size="md" onClick={handleClick} style={{fontFamily:"Poppins"}}>Contact Our Team</Button>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default IndustrialScales;